import {Meter, MeterDimension} from '../types';

const sanitizeDimensions = (dimensions?: MeterDimension[]) => {
    if (!Array.isArray(dimensions)) return undefined;
    return dimensions.map(d => ({
        name: d.name,
        apiKey: d.apiKey,
    }));
};

// Builds the variables payload for the createMeter mutation. Whitelists the
// fields declared on backend CreateMeterInput (meters.graphql) so frontend-only
// fields (createdBy) and server-managed fields (id, updated, createdByUser)
// cannot leak into the mutation variables and trigger AppSync's "field not
// defined for input object type" validation error. See FNP-33.
// FNP-214: MeterDefinition shape — meterCode / aggregation / grain / unit /
// resetPolicy / purpose / lateness + watermark windows replace the legacy
// type + apiKey fields.
export const buildCreateMeterInput = (values: Meter): Record<string, unknown> => {
    const input: Record<string, unknown> = {
        name: values.name,
        meterCode: values.meterCode,
        aggregation: values.aggregation,
        grain: values.grain,
        resetPolicy: values.resetPolicy,
        purpose: values.purpose,
        latenessWindowMinutes: values.latenessWindowMinutes,
        watermarkDelayMinutes: values.watermarkDelayMinutes,
        status: values.status,
    };
    if (values.unit !== undefined && values.unit !== '') input.unit = values.unit;
    const dimensions = sanitizeDimensions(values.dimensions);
    if (dimensions !== undefined) input.dimensions = dimensions;
    if (values.createdByUsername !== undefined) input.createdByUsername = values.createdByUsername;
    if (values.created !== undefined) input.created = values.created;
    return input;
};

// Builds the variables payload for the updateMeter mutation. Whitelists the
// fields declared on backend UpdateMeterInput; includes id (required) and
// updated (which UpdateMeterInput accepts).
export const buildUpdateMeterInput = (values: Meter): Record<string, unknown> => {
    const input: Record<string, unknown> = {
        id: values.id,
        name: values.name,
        meterCode: values.meterCode,
        aggregation: values.aggregation,
        grain: values.grain,
        resetPolicy: values.resetPolicy,
        purpose: values.purpose,
        latenessWindowMinutes: values.latenessWindowMinutes,
        watermarkDelayMinutes: values.watermarkDelayMinutes,
        status: values.status,
    };
    if (values.unit !== undefined && values.unit !== '') input.unit = values.unit;
    const dimensions = sanitizeDimensions(values.dimensions);
    if (dimensions !== undefined) input.dimensions = dimensions;
    if (values.updated !== undefined) input.updated = values.updated;
    return input;
};
